var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomAlarm = function SvgCustomAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47 3.47a.75.75 0 0 1 1.06 1.06l-2 2a.75.75 0 0 1-1.06-1.06l2-2Zm15.06 0a.75.75 0 1 0-1.06 1.06l2 2a.75.75 0 1 0 1.06-1.06l-2-2ZM20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-5.375-3.28a1 1 0 0 1 .156 1.405l-1.857 2.32a1.25 1.25 0 0 1-1.67.26l-2.809-1.873a1 1 0 0 1 1.11-1.664l2.237 1.491 1.427-1.784a1 1 0 0 1 1.406-.156Z",
    fill: "currentColor"
  })));
};

export default SvgCustomAlarm;